import { render } from "./Consonant.vue?vue&type=template&id=24ab0baa"
import script from "./Consonant.vue?vue&type=script&lang=js"
export * from "./Consonant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__